import { render, staticRenderFns } from "./AddHealthCareProviderModal.vue?vue&type=template&id=0c89ecb6&scoped=true"
import script from "./AddHealthCareProviderModal.vue?vue&type=script&lang=ts"
export * from "./AddHealthCareProviderModal.vue?vue&type=script&lang=ts"
import style0 from "./AddHealthCareProviderModal.vue?vue&type=style&index=0&id=0c89ecb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c89ecb6",
  null
  
)

export default component.exports